export let FirstMenuProjection = {
  name: 'projection',
  title: 'Manage projection',
  shortcut: 'p'
}

export const projectionTypes = [
  "mercator",
  "transverseMercator",
  "albersUsa",
  "albers",
  "azimuthalEqualArea",
  "azimuthalEquidistant",
  "conicConformal",
  "conicEqualArea",
  "conicEquidistant",
  "equalEarth",
  "equirectangular",
  "gnomonic",
  "naturalEarth1",
  "orthographic",
  "stereographic"
]

export const customMaps = [
  "texas-map.json"
]